import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, freddyTheme } from '@coolblue-development/freddy';
import { AccountOutlined, CheckmarkCircled, CrossCircled } from '@coolblue-development/icons';
const AccountMenuIcon = ({ isCustomerRecognised }) => (_jsxs(Box, { sx: { position: 'relative' }, children: [_jsx(AccountOutlined, { size: 24 }), _jsx(Box, { sx: {
                position: 'absolute',
                top: `calc(${freddyTheme.spacing[200]} * -1)`,
                right: `calc(${freddyTheme.spacing[200]} * -1)`,
            }, children: isCustomerRecognised ? (_jsx(CheckmarkCircled, { fill: freddyTheme.color.icon.sentimentPositive, innerFill: "contrast" })) : (_jsx(CrossCircled, { fill: freddyTheme.color.icon.accented, innerFill: "contrast" })) })] }));
export default AccountMenuIcon;
//# sourceMappingURL=AccountMenuIcon.js.map